/* global Word console */

import { RemoteAction } from "../remoteActions";

export const debugAction: RemoteAction = {
  name: "addText",
  onExecute: async (data: any) => {
    const text = data.text;
    try {
      await Word.run(async (context) => {
        let body = context.document.body;
        body.insertParagraph(text, Word.InsertLocation.end);
        await context.sync();
      });
      return { added: true };
    } catch (error) {
      console.log("Error: " + error);
    }
    return { added: false };
  },
};
